import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnimation: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconAnimation"><Path d="M2.75 21.25L8.25 15.75M2.75 14.25L5.75 11.25M9.75 21.25L12.75 18.25M21.25 9C21.25 12.4518 18.4518 15.25 15 15.25C11.5482 15.25 8.75 12.4518 8.75 9C8.75 5.54822 11.5482 2.75 15 2.75C18.4518 2.75 21.25 5.54822 21.25 9Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconAnimation;
